// src/components/InputForm.js
import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { addDrone, startSimulation, stopSimulation } from '../../redux/droneSlice';
import { v4 as uuidv4 } from 'uuid';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { Box } from '@mui/material';

const InputForm = ({ sampleData }) => {
  const dispatch = useDispatch();
  const [droneId, setDroneId] = React.useState(null);

  const validationSchema = Yup.object({
    jsonData: Yup.string()
      .required('JSON data is required')
      .test('is-valid-json', 'Invalid JSON format', (value) => {
        try {
          const parsed = JSON.parse(value);
          if (!Array.isArray(parsed)) return false;

          // Ensure each item in the array has the required structure
          return parsed.every(
            (drone) =>
              typeof drone.id === 'string' &&
              Array.isArray(drone.path) &&
              drone.path.every(
                (point) =>
                  typeof point.lat === 'number' &&
                  typeof point.lng === 'number'
              )
          );
        } catch (error) {
          return false;
        }
      }),
  });

  const handleSubmit = (values) => {
    const parsedData = JSON.parse(values.jsonData);
    const id = uuidv4();
    setDroneId(id);
    dispatch(addDrone({ id, path: parsedData }));
  };

  return (
    <Box sx={{ margin: 1 }}>
      <Formik
        initialValues={{
          jsonData: sampleData || '', // Initialize with sampleData or an empty string
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize // Reinitialize form when sampleData changes
      >
        {({ handleSubmit }) => (
          <Form>
            <Box style={{ marginBottom: 10, color: "#fff" }}>Enter JSON Data</Box>
            <Field
              as="textarea"
              id="jsonData"
              name="jsonData"
              rows="5"
              placeholder='[{"id": "drone1", "path": [{"lat": 12.971598, "lng": 77.594566}, ...]}]'
              style={{
                width: "90%",
                backgroundColor: "#111113",
                borderRadius: "5px",
                color: "#fff",
              }}
            />
            <Box style={{ margin: 10, color: "red" }}>
              <ErrorMessage name="jsonData" component="div" className="field-error" />
            </Box>
            <ButtonGroup variant="outlined" aria-label="Basic button group" color="secondary" sx={{ m: 1 }}>
              <Button type="submit">Add Drone</Button>
              <Button
                onClick={() => {
                  if (droneId) dispatch(startSimulation({ id: droneId }));
                }}
              >
                Simulate
              </Button>
              <Button
                onClick={() => {
                  if (droneId) dispatch(stopSimulation({ id: droneId }));
                }}
              >
                Pause
              </Button>
            </ButtonGroup>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default InputForm;
